import type { ApiEnvelope } from '@/types/api.types';
import { apiClient } from '@lib/axios';

import type { BusinessProfile, BusinessProfilePatch } from '../types';

export async function getBusinessProfile(accountId: string): Promise<BusinessProfile> {
  const { data } = await apiClient.get<ApiEnvelope<BusinessProfile>>(
    `/settings/accounts/${accountId}/profile`,
  );
  return data.data;
}

export async function patchBusinessProfile(
  accountId: string,
  patch: BusinessProfilePatch,
): Promise<BusinessProfile> {
  const { data } = await apiClient.patch<ApiEnvelope<BusinessProfile>>(
    `/settings/accounts/${accountId}/profile`,
    patch,
  );
  return data.data;
}
